import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { CustomModal } from 'seagull';
import { withStoreActions } from '~/store/store-context';
import GenericError from '../GenericError/GenericError';
import { isSentryIgnoredError } from './sentryIgnoredError';
class ErrorBoundaryPage extends Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname || prevProps.location.search !== this.props.location.search) {
            this.setState({
                hasError: false
            });
        }
    }
    componentDidCatch(error) {
        // eslint-disable-next-line no-console
        console.error(error);
        if (!isSentryIgnoredError(error)) {
            Sentry.withScope((scope)=>{
                scope.setContext('Error data', error instanceof Error ? {
                    message: error.message,
                    stack: error.stack
                } : {
                    rawError: JSON.stringify(error)
                });
                Sentry.captureException('ErrorBoundaryPage caught an error');
            });
            this.props.actions.logBI(18300);
        }
    }
    render() {
        const { bounded, isModal, children, dismissModal } = this.props;
        const { hasError } = this.state;
        const errorPage = /*#__PURE__*/ _jsx(GenericError, {
            fullPage: !bounded && !isModal,
            testId: "error-boundary-page"
        });
        return hasError ? isModal ? /*#__PURE__*/ _jsx(CustomModal, {
            bi: {
                closeButton: {
                    name: 'error_boundary_modal_close'
                }
            },
            onClose: dismissModal,
            children: errorPage
        }) : errorPage : children;
    }
    constructor(...args){
        super(...args), _define_property(this, "state", {
            hasError: false
        });
    }
}
export default withRouter(withStoreActions(ErrorBoundaryPage));
